import styled from 'styled-components';
import { OpenNewWindow16 } from 'ui/icons/action/OpenNewWindow16';
import { captionLink } from 'ui/theme/typography';
import { Banner, BANNER_VARIANT_ICONS } from 'ui/banner';
import { BannerVariants } from 'ui/banner/types';
import { useBrandAffinityXAIContext } from 'modules/ai/XAI/audienceUserProfile/context/BrandAffinityXAIContext';
import { colors, spacing } from 'ui/theme';
import { ScoreHistory } from './ScoreCard/ScoreHistory';
import { CampaignHistory } from './CampaignCard/CampaignHistory';
import { EngagementHistory } from './EngagementCard/EngagementHistory';
import { constructFlexSpacing, CaptionSecondary } from './Styles';

const Container = styled.div`
  display: grid;
  grid-template-rows: auto;
  grid-template-columns: 1fr;
  row-gap: ${spacing.plusHalf};
`;

const FooterContainer = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 12px;
  justify-content: flex-end;
`;

const CaptionLink = styled.a`
  ${captionLink}
  color: ${colors.textSecondary};
  ${constructFlexSpacing(spacing.quarter)}
`;

const AlignedCaptionRow = styled(CaptionSecondary)`
  ${constructFlexSpacing(spacing.quarter)}
`;

export const XAIContainer = () => {
  const { isError } = useBrandAffinityXAIContext();
  return (
    <Container data-test="brand-affinity-xai-slide-content">
      {isError && (
        <Banner variant={BannerVariants.ERROR} Icon={BANNER_VARIANT_ICONS[BannerVariants.ERROR]}>
          We&apos;re having trouble loading affinity data. Please try again or contact support.
        </Banner>
      )}
      <ScoreHistory />
      <div>
        <CampaignHistory />
        <EngagementHistory />
      </div>
      <FooterContainer>
        <AlignedCaptionRow>
          Learn more about Brand Affinity.{' '}
          <CaptionLink
            target="_blank"
            rel="noopener noreferrer"
            href="https://support.iterable.com/hc/en-us/articles/360052990191-Brand-Affinity"
          >
            See documentation <OpenNewWindow16 />
          </CaptionLink>
        </AlignedCaptionRow>
      </FooterContainer>
    </Container>
  );
};
